import { render, staticRenderFns } from "./BrokerSimulator.vue?vue&type=template&id=96d958b6&scoped=true&"
import script from "./BrokerSimulator.vue?vue&type=script&lang=js&"
export * from "./BrokerSimulator.vue?vue&type=script&lang=js&"
import style0 from "./BrokerSimulator.vue?vue&type=style&index=0&id=96d958b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d958b6",
  null
  
)

export default component.exports